import React, { useState } from "react";
import logo from "../assets/logo.png";
import { useAuthContext } from "../hooks/useAuthContext";
import LoginModal from "./modals/Login";
import { Link } from "react-router-dom";
import ContactSupport from "../pages/modals/ContactSupport";

export default function Header() {
  const { user, dispatch } = useAuthContext();
  const [loginModal, setLoginModal] = useState(false);
  const cancelModal = () => setLoginModal(false);
  const [showSupportModal, setShowSupportModal] = useState(false);

  const closeMenu = () => {
    const nav = document.getElementById("mainNav");
    if (nav && nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  };

  return (
    <nav className="navbar navbar-expand-md p-3 custom-card-light">
      {showSupportModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <ContactSupport onClose={() => setShowSupportModal(false)} />
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      <div className="container">
        <a
          className="navbar-brand d-flex align-items-center gap-2 brand-purple"
          href="/"
          onClick={closeMenu}
        >
          <img src={logo} alt="Border City Software Logo" className="logo" />
          <div className="d-flex flex-column lh-1">
            <span className="fw-bold fs-4">Border City</span>
            <span className="fw-normal fs-4">Software</span>
          </div>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ms-auto gap-3 mt-3 mt-md-0">
            {user ? (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link brand-dark-purple"
                    to="/"
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link brand-dark-purple"
                    to="/MyAccount"
                    onClick={closeMenu}
                  >
                    My Account
                  </Link>
                </li>

                <li className="nav-item pointer">
                  <p
                    className="nav-link brand-dark-purple"
                    onClick={() => {
                      closeMenu();
                      setShowSupportModal(true);
                    }}
                  >
                    Support
                  </p>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link brand-dark-purple"
                    onClick={() => {
                      closeMenu();
                      dispatch({ type: "LOGOUT" });
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link brand-purple-outline"
                    to="/"
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link brand-purple-outline"
                    href="/#services"
                    onClick={closeMenu}
                  >
                    Services
                  </a>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link brand-purple-outline"
                    to="/faq"
                    onClick={closeMenu}
                  >
                    FAQ
                  </Link>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link brand-purple-outline"
                    href="/#contact"
                    onClick={closeMenu}
                  >
                    Contact
                  </a>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link brand-purple-outline"
                    to="/Pricing"
                    onClick={closeMenu}
                  >
                    Pricing
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/signup"
                    className="nav-link brand-purple-outline"
                    onClick={closeMenu}
                  >
                    Sign Up
                  </Link>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link brand-purple-outline"
                    onClick={() => {
                      closeMenu();
                      setLoginModal(true);
                    }}
                  >
                    Login
                  </button>
                </li>

                <li className="nav-item">
                  <a
                    className="btn brand-purple-inline"
                    href="/#get-started"
                    onClick={closeMenu}
                  >
                    Get Started
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      {loginModal && <LoginModal cancelModal={cancelModal} />}
    </nav>
  );
}
